import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['radio', 'submit']

  submit() {
    if (this.radioTarget.checked) {
      this.submitTarget.click()
    }
  }
}
